//基本路由 
export default {
  //登录
  'root_login': resolve => require(['../page/login/root_login.vue'], resolve),
  'apply_ok': resolve => require(['../page/login/apply_ok.vue'], resolve),
  //授权登录
  'login': resolve => require(['../page/login/Login.vue'], resolve),

  //订单详情
  'personal_order_aftersale_detail': resolve => require(['../page/personal_order/Personal_order_aftersale_detail.vue'], resolve),
  'personal_order_aftersale_lists': resolve => require(['../page/personal_order/Personal_order_aftersale_lists.vue'], resolve),
  'personal_order_aftersale_refund': resolve => require(['../page/personal_order/Personal_order_aftersale_refund.vue'], resolve),
  'personal_order_confirm': resolve => require(['../page/personal_order/Personal_order_confirm.vue'], resolve),
  'personal_order_detail': resolve => require(['../page/personal_order/Personal_order_detail.vue'], resolve),
  'personal_order_lists': resolve => require(['../page/personal_order/Personal_order_lists.vue'], resolve),
  'personal_order_logistics': resolve => require(['../page/personal_order/Personal_order_logistics.vue'], resolve),
  'personal_order_select_address': resolve => require(['../page/personal_order/Personal_order_select_address.vue'], resolve),
  'personal_aftersale_close': resolve => require(['../page/personal_order/Personal_aftersale_close.vue'], resolve),

  //店铺消息管理
  'personal_shop': resolve => require(['../page/personal_shop/Personal_shop.vue'], resolve),
  'personal_shop_edit': resolve => require(['../page/personal_shop/Personal_shop_edit.vue'], resolve),
  'personal_sender_list': resolve => require(['../page/personal_shop/Personal_sender_list.vue'], resolve),

  // 求货
  'personal_forGoods_lists': resolve => require(['../page/personal_for_the_goods/Personal_forGoods_lists.vue'], resolve),
  'personal_forGoods_order_lists': resolve => require(['../page/personal_for_the_goods/Personal_forGoods_order_lists.vue'], resolve),
  'personal_forGoods_edit': resolve => require(['../page/personal_for_the_goods/Personal_forGoods_edit.vue'], resolve),
  'personal_forGoods_information': resolve => require(['../page/personal_for_the_goods/personal_forGoods_information.vue'], resolve),
  'personal_forGoods_details': resolve => require(['../page/personal_for_the_goods/Personal_forGoods_details.vue'], resolve),
  'personal_forGoods_order_confirm': resolve => require(['../page/personal_for_the_goods/Personal_forGoods_order_confirm.vue'], resolve),

  //水印 goods_detall_share
  'font_edit': resolve => require(['../page/goods_detall_share/font_edit.vue'], resolve),
  'edit_picture_text': resolve => require(['../page/goods_detall_share/edit_picture_text.vue'], resolve),
  'watermark_edit': resolve => require(['../page/goods_detall_share/watermark_edit.vue'], resolve),

  //商品列表系列
  //满减 goods_lists
  'full_reduction_lists': resolve => require(['../page/goods_lists/full_reduction_lists.vue'], resolve),
  //分类列表
  'classily_screen': resolve => require(['../page/goods_lists/Classily_screen.vue'], resolve),
  //搜索
  'index_search': resolve => require(['../page/goods_lists/Index_search.vue'], resolve),
  // 品牌、标签、筛选、今日推荐
  'middle_good_lists': resolve => require(['../page/goods_lists/Middle_good_lists.vue'], resolve),
  //上新列表
  'personal_message_new': resolve => require(['../page/goods_lists/Personal_message_new.vue'], resolve),

  //商品详情
  'goods_detail': resolve => require(['../page/Goods_detail.vue'], resolve),

  //购物车
  'root_cart': resolve => require(['../page/root_cart/Root_cart.vue'], resolve),
  //支付
  'middle_pay': resolve => require(['../page/root_cart/Middle_pay.vue'], resolve),
  // 发起代付请求
  'middle_pay': resolve => require(['../page/root_cart/Middle_pay.vue'], resolve),
  'please_pay': resolve => require(['../page/pay_another/please_pay.vue'], resolve),
  'demand_payment': resolve => require(['../page/pay_another/demand_payment.vue'], resolve),
  //海关身份单独填写
  'Personal_ID_supplement': resolve => require(['../page/root_cart/Personal_ID_supplement.vue'], resolve),

  // 我的
  'root_personal': resolve => require(['../page/Root_personal.vue'], resolve),
  //消息商城
  'root_message': resolve => require(['../page/Root_message.vue'], resolve),
  //设置
  'personal_application_set': resolve => require(['../page/Personal_application_set.vue'], resolve),
  //商家学堂教程详情
  'message_detail': resolve => require(['../page/Message_detail.vue'], resolve),
  // 关于我们
  'about_us': resolve => require(['../page/about/About_us.vue'], resolve),
  // 注册协议 隐私协议  
  'agreements_policies': resolve => require(['../page/about/agreements_policies.vue'], resolve),
  // 供应商网址提示页面
  'technical_tips': resolve => require(['../page/about/Technical_tips.vue'], resolve),

  //售后订单
  'personal_aftersale_detail': resolve => require(['../page/personal_aftersale/Personal_aftersale_detail.vue'], resolve),
  'personal_aftersale_list': resolve => require(['../page/personal_aftersale/Personal_aftersale_list.vue'], resolve),
  //个人信息页面
  'personal_info': resolve => require(['../page/personal_info/Personal_info.vue'], resolve),
  'personal_info_change_password': resolve => require(['../page/personal_info/Personal_info_change_password.vue'], resolve),
  'personal_info_change_phone_first': resolve => require(['../page/personal_info/Personal_info_change_phone_first.vue'], resolve),
  'personal_info_change_phone_second': resolve => require(['../page/personal_info/Personal_info_change_phone_second.vue'], resolve),
  'edit': resolve => require(['../page/personal_info/Edit.vue'], resolve),
  // 注销账户v4.4.1.1
  'unsubscribe': resolve => require(['../page/personal_info/unsubscribe.vue'], resolve),
  'unsubscribe_agreement': resolve => require(['../page/personal_info/unsubscribe_agreement.vue'], resolve),
  // 特惠爆款入场资格
  'personal_buy_preferential': resolve => require(['../page/personal_info/personal_buy_preferential.vue'], resolve),
  // “高级分销商简介”页面
  'high_introduction': resolve => require(['../page/personal_info/high_introduction.vue'], resolve),
  // 我的等级
  'personal_grade_info': resolve => require(['../page/personal_grade/grade_info.vue'], resolve),
  'personal_privilege_info': resolve => require(['../page/personal_grade/privilege_info.vue'], resolve),
  'personal_rules_info': resolve => require(['../page/personal_grade/rules_info.vue'], resolve),

  // 卡券包
  'coupon_list': resolve => require(['../page/member/coupon_list.vue'], resolve),
  'coupon_history_list': resolve => require(['../page/member/coupon_history_list.vue'], resolve),
  'choice_coupon': resolve => require(['../page/member/choice_coupon.vue'], resolve),
  // 会员权益
  'member_gift': resolve => require(['../page/member/member_gift.vue'], resolve),
  // 会员礼包商品列表
  'member_goods_list': resolve => require(['../page/member/member_goods_list.vue'], resolve),
  'member_goods_details': resolve => require(['../page/member/member_goods_details.vue'], resolve),
  'gift_order_confirm': resolve => require(['../page/member/gift_order_confirm.vue'], resolve),
  'gift_order_success': resolve => require(['../page/member/gift_order_success.vue'], resolve),

  // 分销商二维码分享
  'personal_qrcode': resolve => require(['../page/Personal_qrcode.vue'], resolve),
  //收藏
  'personal_collect': resolve => require(['../page/Personal_collect.vue'], resolve),
  //分类
  'root_classify': resolve => require(['../page/Root_classify.vue'], resolve),
  //分类管理
  'personal_classification': resolve => require(['../page/Personal_classification.vue'], resolve),
  //地址管理
  'personal_address': resolve => require(['../page/personal_address/Personal_address.vue'], resolve),
  'personal_address_edit': resolve => require(['../page/personal_address/Personal_address_edit.vue'], resolve),

  // 自提点管理
  'pickupadress': resolve => require(['../page/pickupadress/pickupadress.vue'], resolve),


  // 支付人管理
  'payer_list': resolve => require(['../page/payer_list/Payer_list.vue'], resolve),
  'payer_list_edit': resolve => require(['../page/payer_list/Payer_list_edit.vue'], resolve),
  // 短信中间跳转支付人修改页
  'dx': resolve => require(['../page/payer_list/dx.vue'], resolve),

  //客户管理 客户订单
  'personal_customer': resolve => require(['../page/personal_customer/Personal_customer.vue'], resolve),
  'add_member_customer': resolve => require(['../page/personal_customer/add_member_customer.vue'], resolve),
  'personal_customernews': resolve => require(['../page/personal_customer/Personal_customerNews.vue'], resolve),
  'personal_customerorder_aftersale': resolve => require(['../page/personal_customer/Personal_customerOrder_aftersale.vue'], resolve),
  'personal_customerorder_aftersalelogistics': resolve => require(['../page/personal_customer/Personal_customerOrder_aftersalelogistics.vue'], resolve),
  'personal_customerorder_lists': resolve => require(['../page/personal_customer/Personal_customerOrder_lists.vue'], resolve),
  'personal_customer_detail': resolve => require(['../page/personal_customer/Personal_customer_detail.vue'], resolve),
  'personal_customerorder_aftersale_lists': resolve => require(['../page/personal_customer/personal_customerOrder_aftersale_lists.vue'], resolve),
  'personal_customerorder_detail': resolve => require(['../page/personal_customer/personal_customerOrder_detail.vue'], resolve),
  'personal_customerorder_detail_address_edit': resolve => require(['../page/personal_customer/personal_customerOrder_detail_address_edit.vue'], resolve),
  // 商品管理
  'personal_goods_manage': resolve => require(['../page/personal_goods_manage/Personal_goods_manage.vue'], resolve),
  'personal_goods_manage_add': resolve => require(['../page/personal_goods_manage/Personal_goods_manage_add.vue'], resolve),
  'personal_goods_manage_add_mark': resolve => require(['../page/personal_goods_manage/Personal_goods_manage_add_mark.vue'], resolve),
  'personal_goods_manage_goods': resolve => require(['../page/personal_goods_manage/Personal_goods_manage_goods.vue'], resolve),
  'personal_goods_manage_goods_detail': resolve => require(['../page/personal_goods_manage/Personal_goods_manage_goods_detail.vue'], resolve),
  'personal_goods_manage_goods_price': resolve => require(['../page/personal_goods_manage/Personal_goods_manage_goods_price.vue'], resolve),
  // 收入管理
  'personal_income': resolve => require(['../page/personal_income/Personal_income.vue'], resolve),
  'personal_income_putforward': resolve => require(['../page/personal_income/Personal_income_putforward.vue'], resolve),
  'personal_income_putforward_list': resolve => require(['../page/personal_income/Personal_income_putforward_list.vue'], resolve),
  'personal_income_trade': resolve => require(['../page/personal_income/Personal_income_trade.vue'], resolve),
  'personal_income_mybankcard': resolve => require(['../page/personal_income/Personal_income_mybankcard.vue'], resolve),
  'add_withdrawal_account': resolve => require(['../page/personal_income/add_withdrawal_account.vue'], resolve),
  'revenue_management': resolve => require(['../page/personal_income/Revenue_management.vue'], resolve),


  //客服、商家聊天
  'chat': resolve => require(['../page/Chat.vue'], resolve),
  //商家学堂
  'personal_business_school': resolve => require(['../page/Personal_business_school.vue'], resolve),

  //分享开店进来注册页面 other_page
  'apply_shop': resolve => require(['../page/other_page/Apply_shop.vue'], resolve),
  //下载页 
  'download': resolve => require(['../page/other_page/download.vue'], resolve),
  // 美街下载
  'meistreetDownload': resolve => require(['../page/other_page/meistreetDownload.vue'], resolve),
  'meigouDownload': resolve => require(['../page/other_page/meigouDownload.vue'], resolve),
  // 视频播放页
  'video': resolve => require(['../components/video/Video.vue'], resolve),

  'test': resolve => require(['../page/test.vue'], resolve),

  //二级页面
  'tow': resolve => require(['../page/Index.1.vue'], resolve),
  //首页
  '/': resolve => require(['../page/Index.vue'], resolve),

  /*云仓管理中心*/
  'build_warehouse': resolve => require(['../page/cloud_warehouse/build_warehouse.vue'], resolve),
  'build_goods_details': resolve => require(['../page/cloud_warehouse/build_goods_details.vue'], resolve),
  'build_record': resolve => require(['../page/cloud_warehouse/build_record'], resolve),
  'mine_cloud_warehouse': resolve => require(['../page/cloud_warehouse/mine_cloud_warehouse.vue'], resolve),
  'mine_cloud_goods_details': resolve => require(['../page/cloud_warehouse/mine_cloud_goods_details.vue'], resolve),
  'matching_change_record': resolve => require(['../page/cloud_warehouse/matching_change_record.vue'], resolve),
  'allot_order_select_goods': resolve => require(['../page/cloud_warehouse/allot_order_select_goods.vue'], resolve),
  'allot_order_confirm_order': resolve => require(['../page/cloud_warehouse/allot_order_confirm_order.vue'], resolve),
  'already_allot_order': resolve => require(['../page/cloud_warehouse/already_allot_order.vue'], resolve),
  'already_allot_order_details': resolve => require(['../page/cloud_warehouse/already_allot_order_details.vue'], resolve),
  'confirm_build_order': resolve => require(['../page/cloud_warehouse/confirm_build_order.vue'], resolve),

  // 门店会员注册
  'store_signup': resolve => require(['../page/store_sign_up/signup.vue'], resolve),
  'register_success': resolve => require(['../page/store_sign_up/register_success.vue'], resolve),
  'shop_sales_data':resolve => require(['../page/report_dashboard/report.vue'],resolve ),
  //更多报表
  'other_reports':resolve => require(['../page/report_dashboard/other_reports.vue'],resolve ),
  'other_reports_detail':resolve => require(['../page/report_dashboard/other_reports_detail.vue'],resolve ),
  
  // 美街支付成功
  'qfpay_checkstand_success':resolve => require(['../page/payment/payment_success.vue'],resolve ),
  'qfpay_checkstand_fail':resolve => require(['../page/payment/pament_fail.vue'],resolve ),


  // 提货人管理
  'consignee': resolve => require(['../page/consignee/list.vue'], resolve),
  'consignee_edit': resolve => require(['../page/consignee/edit.vue'], resolve),
}


// WEBPACK FOOTER //
// ./src/routes/base.js